import React, { Component } from 'react';
import firebase from 'firebase';
import { translate } from 'react-i18next';
import { firebaseConnect } from 'react-redux-firebase';
import { AppWelcome } from 'medua-components';

/* eslint-disable */
@firebaseConnect()
@translate('auth')
export default class ResetPassword extends Component {


  constructor(props) {
    super(props);
    this.state = {
      email: '',
      sent: false,
      error: '',
    };
    this.handleReset = this.handleReset.bind(this);
  }

  handleReset(e) {
    e.preventDefault();
    this.setState({ sent: false, error: '' })
    firebase.auth().sendPasswordResetEmail(this.state.email).then(() => {
      this.setState({ sent: true })
    }).catch(error => {
      this.setState({ error: error.message })
    });
  }

  render() {
    return (
      <AppWelcome
        reset
        title={ this.props.t('auth:reset-password.title') }
        success={ this.state.sent }
        error={ this.state.error }
        placeholder={{
          email: this.props.t('auth:reset-password.placeholder.email')
        }}
        text={{
          forgot: this.props.t('auth:reset-password.text.forgot'),
          success: this.props.t('auth:reset-password.text.success'),
          reset: this.props.t('auth:reset-password.text.reset')
        }}
        onSubmit={ this.handleReset }
        onEmailChange={ (e) => this.setState({ email: e.target.value })}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/auth/reset-password/index.jsx